import { render } from "./communal-fee-setting.vue?vue&type=template&id=313a3527&scoped=true&ts=true"
import script from "./communal-fee-setting.vue?vue&type=script&lang=ts"
export * from "./communal-fee-setting.vue?vue&type=script&lang=ts"

import "./communal-fee-setting.vue?vue&type=style&index=0&id=313a3527&scoped=true&lang=less"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313a3527"]])

export default __exports__